import { OPEN_MODAL } from '../actions/constants';

const INITIAL_STATE = {
  content: null, // the content of the open modal (or null if closed)
  onForceClose: null, // an optional handler that will be called when the X in top-right is clicked
};

const ReactModal = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OPEN_MODAL: {
      return {
        ...state,
        content: action.payload.content,
        onForceClose: action.payload.onForceClose,
      };
    }
    default:
      return state;
  }
};

export default ReactModal;
